import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { required, SelectInput, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const MoveToGroupDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const [groups, setGroups] = useState([]);

  const fetchGroups = async () => {
    if (!record?.studentEducationId) return false;
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudyGroupsSelect({
          course: record?.currentCourse,
          instructionLanguageId: record?.instructionLanguageId,
          studyTypeId: record?.studyTypeId,
          specialityId: record?.specialityId,
          showNewGroupOptions: true,
        }),
        null,
        "GET",
      );
      // The current group is never a valid target, so the check runs on what the select would show.
      const availableGroups = (data ?? []).filter(group => group.id !== record?.studyGroup);
      if (!availableGroups.length) {
        notify("Няма налични групи за този студент", { type: "warning" });
        return false;
      }
      setGroups(availableGroups);
    } catch (error) {
      notify("Грешка при зареждане на групите", { type: "error" });
      return false;
    }
  };

  const handleConfirm = async values => {
    await dataProvider.customRequest(
      studentRequests.moveStudyGroup(),
      {
        studentEducationId: record.studentEducationId,
        newGroup: values.newGroup,
      },
      "PUT",
    );
    notify("Успешно заявена промяна", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      onOpen={fetchGroups}
      titleContent="Премести студент в група"
      onConfirm={handleConfirm}
      triggerButton={<Button startIcon={<MoveUpIcon />}>Премести</Button>}
    >
      <Typography>
        Текуща група на студента: <strong>{record?.studyGroup ? `Група ${record.studyGroup}` : "Няма група"}</strong>
      </Typography>
      <SelectInput
        source="newGroup"
        label="Избери група"
        validate={required()}
        emptyText={false}
        choices={groups}
      />
    </FormModal>
  );
};

export default MoveToGroupDialog;
